var map = {
	"./icons8-.net-framework-144.png": 5743,
	"./icons8-.net-framework-48.png": 1896,
	"./icons8-.net-framework-96.png": 9881,
	"./icons8-android-studio-144.png": 1607,
	"./icons8-android-studio-96.png": 7697,
	"./icons8-angular-144.png": 477,
	"./icons8-angularjs-96.png": 296,
	"./icons8-api-96.png": 4125,
	"./icons8-app-store-144.png": 3242,
	"./icons8-app-store-96.png": 3518,
	"./icons8-c-sharp-logo-96.png": 1617,
	"./icons8-cloud-firestore-96.png": 1812,
	"./icons8-dart-144.png": 5844,
	"./icons8-dart-96.png": 4464,
	"./icons8-external-link-144.png": 3513,
	"./icons8-firebase-96.png": 1324,
	"./icons8-flutter-144.png": 9857,
	"./icons8-flutter-96.png": 6971,
	"./icons8-google-firebase-console-144.png": 1089,
	"./icons8-google-play-96.png": 6717,
	"./icons8-html-144.png": 7500,
	"./icons8-html-5-96.png": 1802,
	"./icons8-java-144.png": 5191,
	"./icons8-java-96.png": 1678,
	"./icons8-javascript-96.png": 9170,
	"./icons8-microsoft-sql-server-144.png": 6934,
	"./icons8-microsoft-sql-server-96.png": 122,
	"./icons8-mysql-144.png": 8173,
	"./icons8-mysql-logo-96.png": 5919,
	"./icons8-play-store-144.png": 6201,
	"./icons8-spring-boot-144.png": 9863,
	"./icons8-spring-boot-96.png": 8033,
	"./icons8-typescript-144.png": 8534,
	"./icons8-typescript-96.png": 586,
	"./icons8-visual-basic-96.png": 1650,
	"./icons8-visual-studio-144.png": 6724,
	"./icons8-visual-studio-96.png": 5520,
	"./icons8-visual-studio-code-2019-144.png": 2731,
	"./icons8-visual-studio-code-2019-48.png": 4484,
	"./icons8-visual-studio-code-2019-96.png": 1589,
	"./icons8-vue-js-96.png": 5585,
	"./icons8-xamarin-144.png": 9621,
	"./icons8-xamarin-96.png": 2639,
	"./icons8-xaml-96.png": 6147
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2270;